// import $ from 'jquery';
import { getCookieData, getI18NMessage } from '../service';
import { getConfirmToastTemplate, BtnApply, BtnDeny, BtnConfig, GCookieConfirmToastId, GCookieConfirmDimmedId, IsActive, BtnApplyOptional, ContentWrap } from '../template/confirmToast';
import { getCountry, getLang, getPlayncDomain } from '../util/util';
import AbsGlobalCookie from './AbsGlobalCookie';

export default class ConfirmToast extends AbsGlobalCookie{
    curOptCookieListVer!: string;
    zIndex: number;
    apiDomain: string;
    contiCookieDataApi: string;
    contiApiUrl: string;
    // getAllCookieNamesFromConti!: () => Record<keyof CookieDatas, string[]>;

    cookieNamesToDelete!: ReturnType<InstanceType<typeof AbsGlobalCookie>['_getNotAppiedCookieNames']>;

    constructor({zIndex = 1, apiDomain = '', contiCookieDataApi = ''}: {zIndex?: number, apiDomain?: string, contiCookieDataApi?: string} = {}){
        super();

        this.zIndex = zIndex;
        this.apiDomain = apiDomain;
        this.contiCookieDataApi = contiCookieDataApi;
        this.contiApiUrl = this.apiDomain + this.contiCookieDataApi
        this.init();

        // console.log(this.zIndex);
    }

    async init(): Promise<void>{

        try{
            // 허용된 언어만 선택
            let lang = getLang({onlyUsingLanguageArr: ['ar', 'en', 'id', 'ja', 'ko', 'th', 'zh', 'ru'], defaultLang: 'en'});
            let country = getCountry();

            // 국가정보가 한국일때는 출력 안함
            if(this.isKoreaLanguge()) {
                // console.log('한국어 입니다.');
                return;
            }

            // I18N 받아오기 & 쿠키 리스트 받아오기 (쿠키 리스트 언어는 항상 en)
            let textData = (await getI18NMessage(lang)).confirmToast;
            let cookieDataWrap = await getCookieData(country, this.contiApiUrl);

            let cookieDataOptionals = this._getCookieDataOptionals(cookieDataWrap) as ContiContentAPIResponse<CONTI_ALIAS_GLOBAL_COOKIE_LIST_OPTIONALS>;
            let cookieDataRequired = this._getCookieDataRequired(cookieDataWrap) as ContiContentAPIResponse<CONTI_ALIAS_GLOBAL_COOKIE_LIST_REQUIRED>;

            // 선택 쿠키 버전
            this.curOptCookieListVer = String(cookieDataOptionals.version);

            // 쿠키 데이터
            let cookieDatas: CookieDatas = this._getCookeDatas(cookieDataOptionals, cookieDataRequired);

            // 쿠키 데이터가 필요한 메서드 (왜 this.cookeDatas 로 하여 사용하지 않는가? 그냥.)
            // this.getAllCookieNamesFromConti = super.getAllCookieNamesFromConti.bind(this, cookieDatas);
            this.cookieNamesToDelete = this.getCookieNamesToDeleteSuper(cookieDatas);



            // 저장하지 않은 타입의 First-party 쿠키 삭제 (여기서 해줘야 하나?)
            // window.onload 시점으로 잡을수 없는 이유는
            // ConfirmToast 의 init() 이 async 함수로,
            // init() 내부에서 ajax 통신을 통해 쿠키 데이터를 가져오는데,
            // 이때 비동기 화 되면서, window.onload 이벤트 걸기전에,
            // window load 가 완료 되버리는 경우가 생긴다.

            // 테스트 결과 간헐적으로 window.onload 이벤트 거는 곳까지 window load가 안되는 경우가 있는데,
            // 그건 init() 내부의 ajax 통신이 document 의 스크립트 로드보다 빨라서 window load 시점이 안되었기 때문으로 보인다.

            // ajax로 파일을 로드 할경우 ajax 호출의 경우 완료가 안되도, window.onload 가 발생하고, 이후에 파일을 이어서 받아온다.
            // https://docs.newrelic.com/docs/browser/new-relic-browser/page-load-timing-resources/page-load-timing-process/
            // The page finishes rendering in the user's browser and the window load event fires. (For pages that use asynchronous loading, some elements may continue to load after the window load event occurs.)
            this.deleteCookies(this.cookieNamesToDelete);

            //  토스트창 출력해도 되는지 API로 확인
            let isOpenLayer = this._chkIsOpenLayer(this.curOptCookieListVer);

            if(!isOpenLayer) return;


            // 템플릿 세팅
            this.setTemplate(textData, this.zIndex);

            // 이벤트 바인딩
            this.bindEvent();

            // 토스트 레이어 오픈
            this.diplayToastAndDimmed(true);

            window.showToast = this.diplayToastAndDimmed.bind(null, true);


        }catch(err){
            // console.error(err);
        }
    }

    setTemplate(textData: ConfirmToastTextData, zIndex?: number): void{
        // 템플릿 만들기
        let template = getConfirmToastTemplate(textData, zIndex);

        // 템플릿 붙이기

        // $('body').append(template);
        document.body.insertAdjacentHTML('beforeend',template);

    }

    bindEvent(): void{
        // 모두 동의하기 클릭
        // $(document).on('click', `#${GCookieConfirmToastId} .${BtnApply}`, (this.onClickBtnApply));
        document.addEventListener('click', (e) => {
            const delegateTarget = (e.target as HTMLElement)?.closest(`#${GCookieConfirmToastId} .${BtnApply}`);
            delegateTarget && this.onClickBtnApply();
        });

        // 모두 거부하기 클릭
        // $(document).on('click', `#${GCookieConfirmToastId} .${BtnDeny}`, this.onClickBtnDeny);
        document.addEventListener('click', (e) => {
            const delegateTarget = (e.target as HTMLElement)?.closest(`#${GCookieConfirmToastId} .${BtnDeny}`);
            delegateTarget && this.onClickBtnDeny();
        });

        // 선택 통의하기 클릭
        // $(document).on('click', `#${GCookieConfirmToastId} .${BtnApplyOptional}`, this.onClickBtnApplyOptional);
        document.addEventListener('click', (e) => {
            const delegateTarget = (e.target as HTMLElement)?.closest(`#${GCookieConfirmToastId} .${BtnApplyOptional}`);
            delegateTarget && this.onClickBtnApplyOptional();
        });
        // 설정 클릭
        // $(document).on('click', `#${GCookieConfirmToastId} .${BtnConfig}`, this.onClickBtnSetting);
        document.addEventListener('click', (e) => {
            const delegateTarget = (e.target as HTMLElement)?.closest(`#${GCookieConfirmToastId} .${BtnConfig}`);
            delegateTarget && this.onClickBtnSetting();
        });
        // 쿠키정책(a 태크) 클릭시
        // $(document).on('click', `#${GCookieConfirmToastId} .${ContentWrap} a`, this.onClickContentWrapAnchorTag);
        document.addEventListener('click', (e) => {
            const delegateTarget = (e.target as HTMLElement)?.closest(`#${GCookieConfirmToastId} .${ContentWrap} a`);
            delegateTarget && this.onClickContentWrapAnchorTag(e);
        });
        // 딤드 클릭
        // $(document).on('click', `#${GCookieConfirmDimmedId}`, this.onClickDimmed);
        document.addEventListener('click', (e) => {
            const delegateTarget = (e.target as HTMLElement)?.closest(`#${GCookieConfirmDimmedId}`);
            delegateTarget && this.onClickDimmed();
        });
    }

    // a 태그(쿠키정책) 클릭시
    onClickContentWrapAnchorTag = (e: MouseEvent):void => {
        e.preventDefault();

        // 쿠키허용상태를 저장하는 쿠키 생성
        this._applyCookieOnlyRequired(this.curOptCookieListVer, this.URL_COOKIE_POLICY_LAYER_OPEN);

    };

    // 딤드 클릭
    onClickDimmed = (): void => {
        // 쿠키허용상태를 저장하는 쿠키 생성
        this._applyCookieOnlyRequired(this.curOptCookieListVer, location.href);

        // 레이어 닫기
        this.diplayToastAndDimmed(false);
    };

    // 선택 동의 클릭
    onClickBtnApplyOptional = ():void => {
        // 쿠키허용상태를 저장하는 쿠키 생성
        this._applyCookieOnlyRequired(this.curOptCookieListVer, this.URL_COOKIE_POLICY_LAYER_OPEN);
    };

    // 설정 클릭
    onClickBtnSetting = (): void => {
        // 쿠키허용상태를 저장하는 쿠키 생성
        this._applyCookieOnlyRequired(this.curOptCookieListVer, this.URL_COOKIE_POLICY_LAYER_OPEN);
    };

    // 모두 거부하기 클릭
    onClickBtnDeny = ():void => {
        // 쿠키허용상태를 저장하는 쿠키 생성
        this._applyCookieOnlyRequired(this.curOptCookieListVer, location.href);

        // 레이어 닫기
        this.diplayToastAndDimmed(false);
    };

    // 모두 동의 하기 클릭
    onClickBtnApply = (): void => {

        // 쿠키허용상태를 저장하는 쿠키 생성
        this._applyCookieAll(this.curOptCookieListVer, location.href);

        // 레이어 닫기
        this.diplayToastAndDimmed(false);
    };


    /**
    * 토스트 팝업 디스 플레이
    */
    diplayToastAndDimmed = (flag: boolean):void => {
        this.displayDimmed(flag);
        this.displayToast(flag);
    };

    displayDimmed(flag: boolean): void{
        if(flag){
            //   $(`#${GCookieConfirmDimmedId}`).addClass(IsActive);
            document.getElementById(GCookieConfirmDimmedId)?.classList.add(IsActive);
        }else{
            // $(`#${GCookieConfirmDimmedId}`).removeClass(IsActive);
            document.getElementById(GCookieConfirmDimmedId)?.classList.remove(IsActive);
        }
    }

    displayToast(flag: boolean): void{
        if(flag){
            //   $(`#${GCookieConfirmToastId}`).addClass(IsActive);
            document.getElementById(GCookieConfirmToastId)?.classList.add(IsActive);
        }else{
            //   $(`#${GCookieConfirmToastId}`).removeClass(IsActive);
            document.getElementById(GCookieConfirmDimmedId)?.classList.remove(IsActive);
        }
    }




}

